import { useEffect } from 'react';

import { useAnchorValue } from './use-anchor-value';

export const useStandardAnchorScroll = () => {
    const anchorValue = useAnchorValue();

    useEffect(() => {
        if (anchorValue) {
            const targetId = anchorValue.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }
    }, [anchorValue]);
};
